import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoRydeLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 100,
	viewBox: "0 0 25 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_104_4060)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M17.0846 91.4123L17.0846 93.9914L24.4122 93.9914L24.4122 99.7143L0.583252 99.7143L0.583252 90.4651C0.583251 88.6331 0.942834 87.0412 1.65761 85.6938C2.37239 84.3464 3.39414 83.3059 4.72284 82.5722C6.05154 81.8385 7.61265 81.4739 9.40618 81.4739C11.1997 81.4739 12.6337 81.8163 13.9185 82.5011C15.199 83.1858 16.2032 84.1641 16.9311 85.4359L24.421 81.0692L24.421 87.1968L17.0934 91.4123L17.0846 91.4123ZM6.11293 90.1716L6.11293 93.7601L11.2523 93.7601L11.2523 90.1716C11.2523 88.7309 10.1034 87.5659 8.68263 87.5659C7.26184 87.5659 6.11293 88.7309 6.11293 90.1716V90.1716Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.8699 63.9316L24.4166 63.9316L24.4166 69.6545L15.769 69.6545L0.583252 77.374L0.583252 71.3309L10.0464 66.5329L0.583251 61.7349L0.583251 56.1854L15.8699 63.9316Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.207 11.3047L24.4166 11.3047L24.4166 27.553L0.583252 27.553L0.583251 11.6826L5.79282 11.6826L5.79282 21.8879L9.80962 21.8879L9.80962 12.8966L14.8482 12.8966L14.8482 21.8879L19.207 21.8879L19.207 11.3091L19.207 11.3047Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4166 33.2537L24.4166 42.823C24.4166 45.0375 23.9298 47.0029 22.9519 48.7193C21.9784 50.4358 20.5927 51.7653 18.7992 52.7081C17.0057 53.6508 14.9052 54.1266 12.5021 54.1266C10.099 54.1266 7.99856 53.6552 6.20503 52.7081C4.4115 51.7653 3.02579 50.4358 2.05229 48.7193C1.07878 47.0029 0.587646 45.0375 0.587646 42.823L0.587646 33.2537L24.4166 33.2537ZM19.036 38.9766L5.96385 38.9766L5.96385 42.5918C5.96385 44.326 6.54269 45.7178 7.70037 46.7672C8.85805 47.8167 10.4586 48.3414 12.5021 48.3414C14.5456 48.3414 16.1462 47.8167 17.3039 46.7672C18.4615 45.7178 19.0404 44.326 19.0404 42.5918L19.0404 38.9766L19.036 38.9766Z",
					fill: "#40E098"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.5667 0.285703L18.5667 5.42166L24.4121 5.42166L24.4121 0.285702L18.5667 0.285703Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_104_4060",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 99.4286,
				height: 23.8333,
				fill: "white",
				transform: "translate(0.583252 99.7143) rotate(-90)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogoRydeLeft);
export { ForwardRef as ReactComponent };
